import { setIn } from 'formik';

import { cleanObject } from '../../utils/hooksLib';

// Actions
export const SET_ERROR_FIELDS = 'SET_ERROR_FIELDS';
export const CLEAR_FIELD_ERROR = 'CLEAR_FIELD_ERROR';
export const SET_ATTACHMENT_ERROR = 'SET_ATTACHMENT_ERROR';
export const CLEAR_ATTACHMENT_ERROR = 'CLEAR_ATTACHMENT_ERROR';
export const SET_CONTACT_ERROR = 'SET_CONTACT_ERROR';
export const CLEAR_CONTACT_ERROR = 'CLEAR_CONTACT_ERROR';
export const SET_FINANCIAL_ATTACHMENT_ERROR = 'SET_FINANCIAL_ATTACHMENT_ERROR';
export const CLEAR_FINANCIAL_ATTACHMENT_ERROR = 'CLEAR_FINANCIAL_ATTACHMENT_ERROR';

export const fieldErrorInitial = {};

// Reducer
export function fieldError(state, action) {
  if (!state) {
    state = fieldErrorInitial;
  }

  switch (action.type) {
    case SET_ERROR_FIELDS: {
      const updatedState = JSON.parse(JSON.stringify(action.payload));
      if (
        state.shipTo &&
        state.shipTo.length === 1 &&
        (state.shipTo[0].coa || state.shipTo[0].packingList || state.shipTo[0].orderConfirmation)
      ) {
        return updatedState;
      } else {
        return { ...state, ...action.payload };
      }
    }
    case CLEAR_FIELD_ERROR: {
      const errors = setIn(state, action.payload);
      return cleanObject(errors);
    }
    case SET_ATTACHMENT_ERROR:
      return {
        ...state,
        attachmentCard: { ...state.attachmentCard, ...action.payload }
      };
    case SET_FINANCIAL_ATTACHMENT_ERROR:
      return { ...state, financialAttachmentCard: { ...action.payload } };
    case CLEAR_ATTACHMENT_ERROR:
      return updateAttachmentError(state, action.payload);
    case CLEAR_FINANCIAL_ATTACHMENT_ERROR:
      return updateFinancialAttachmentError(state, action.payload);
    case SET_CONTACT_ERROR:
      return {
        ...state,
        contactCard: { ...state.contactCard, ...action.payload }
      };
    case CLEAR_CONTACT_ERROR:
      return updateContactCardError(state, action.payload);
    default:
      return state;
  }
}

// Action Creators
export function setErrorFields(payload) {
  return { type: SET_ERROR_FIELDS, payload };
}

export function setAttachmentError(payload) {
  return { type: SET_ATTACHMENT_ERROR, payload };
}

// Action Creators
export function clearFieldError(payload) {
  return { type: CLEAR_FIELD_ERROR, payload };
}

export function clearAttachmentError(payload) {
  return { type: CLEAR_ATTACHMENT_ERROR, payload };
}

export function clearFinancialAttachmentError(payload) {
  return { type: CLEAR_FINANCIAL_ATTACHMENT_ERROR, payload };
}

// Action Creators
export function clearContactCardError(payload) {
  return { type: CLEAR_CONTACT_ERROR, payload };
}

export function setContactCardError(payload) {
  return { type: SET_CONTACT_ERROR, payload };
}

export function setfinancialAttachmentCardError(payload) {
  return { type: SET_FINANCIAL_ATTACHMENT_ERROR, payload };
}

// Data helpers
export function updateContactCardError(state, field) {
  if (Object.prototype.hasOwnProperty.call(state, 'contactCard')) {
    const { contactCard } = state;
    if (Object.prototype.hasOwnProperty.call(contactCard, field)) {
      delete contactCard[field];
      if (contactCard && Object.keys(contactCard).length === 0 && contactCard.constructor === Object) {
        delete state['contactCard'];
        return state;
      }
      return { ...state, contactCard: { ...contactCard } };
    }
    return state;
  }
  return state;
}

export function updateAttachmentError(state, field) {
  if (Object.prototype.hasOwnProperty.call(state, 'attachmentCard')) {
    const { attachmentCard } = state;
    if (Object.prototype.hasOwnProperty.call(attachmentCard, field)) {
      delete attachmentCard[field];
      if (attachmentCard && Object.keys(attachmentCard).length === 0 && attachmentCard.constructor === Object) {
        delete state['attachmentCard'];
        return state;
      }
      return { ...state, attachmentCard: { ...attachmentCard } };
    }
    return state;
  }
  return state;
}

export function updateFinancialAttachmentError(state, field) {
  if (Object.prototype.hasOwnProperty.call(state, 'financialAttachmentCard')) {
    const { financialAttachmentCard } = state;
    if (Object.prototype.hasOwnProperty.call(financialAttachmentCard, field)) {
      delete financialAttachmentCard[field];
      if (
        financialAttachmentCard &&
        Object.keys(financialAttachmentCard).length === 0 &&
        financialAttachmentCard.constructor === Object
      ) {
        delete state['financialAttachmentCard'];
        return state;
      }
      return {
        ...state,
        financialAttachmentCard: { ...financialAttachmentCard }
      };
    }
    return state;
  }
  return state;
}
